import axios from "axios";

const adminApi = axios.create({
	baseURL: `${import.meta.env.VITE_ADMIN_API_URL}/api`,
	withCredentials: true,
});

export default adminApi;
